export const PURPOSE_LABELS = { sourcing: "Sourcing enquiry", catalogue: "Catalogue request", "custom-development": "Custom development", samples: "Sample enquiry", "compliance-documents": "Compliance document request", meeting: "Meeting request" };
export const EVENT_LABELS = { "ambiente-2027": "Ambiente 2027", "ihgf-spring-2027": "IHGF Spring 2027" };

export function meetingTimeLabel(start, end, timeZone = "Europe/Berlin") {
  if (!start) return "";
  const date = new Date(start);
  const finish = end ? new Date(end) : null;
  if (Number.isNaN(date.getTime())) return "";
  try {
    const day = new Intl.DateTimeFormat("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone }).format(date);
    const time = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone });
    const zone = new Intl.DateTimeFormat("en-GB", { timeZone, timeZoneName: "short" }).formatToParts(date).find((part) => part.type === "timeZoneName")?.value || timeZone;
    return day + " · " + time.format(date) + (finish && !Number.isNaN(finish.getTime()) ? "–" + time.format(finish) : "") + " " + zone;
  } catch { return "Meeting time to be confirmed"; }
}
